import { selectReportsState } from 'modules/settings/submodules/clients/reports/store/selectors';
import { IStore } from 'store/configureStore';

export const selectEcubReportState = (state: IStore) => selectReportsState(state).ecubReport;
export const selectEcubReportActiveTab = (state: IStore) => selectEcubReportState(state).activeTab;
export const selectEcubReportIsLoading = (state: IStore) => selectEcubReportState(state).isLoading;
export const selectEcubReportItems = (state: IStore) => selectEcubReportState(state).table?.items || [];
export const selectEcubReportPauseInProgress = (state: IStore) => selectEcubReportState(state).isPauseInProgress;
